import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type {
  PreviewTeamMemberUploadRequestBody,
  PreviewTeamMemberUploadResponseBody,
  UseTeamMemberListParams,
} from './types';

export const usePreviewTeamMemberUpload: MutationFunction<
  PreviewTeamMemberUploadResponseBody,
  PreviewTeamMemberUploadRequestBody,
  [UseTeamMemberListParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ file }) => {
      const formData = new FormData();
      formData.append('file', file);

      return request(`/suppliers/${params.locator}/members_upload/preview`, {
        init: {
          method: 'POST',
          body: formData,
        },
      });
    },
    ...queryOptions,
    mutationKey: ['groups', 'teamMembers', 'previewUpload'],
  });
};
